import angular from 'angular';

/**
 * Legacy module — preserved as empty so deps keep resolving.
 * Real implementation: apps/b2b-frontend/app/core/address/location.service.ts
 * Registered via downgradeInjectable in
 * apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 *
 * The 'acme.common.service.api' dep is preserved for module-graph parity
 * (the legacy LocationService declared it).
 */
export { LocationService } from '@ng/core/address/location.service';

export const LocationServiceModule = angular.module('acme.common.service.location', ['acme.common.service.api']).name;
